module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAANElEQVQokWO0t/f8z0AGYIHSjCTq+89Ejm3INsJNIqAe7jJ0jUQ7edSpmGAAnUqxH0lO6ADVhwb03O017AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/assets/21c.png
// module id = pvi0
// module chunks = 64